import { render, staticRenderFns } from "./Lettering.vue?vue&type=template&id=c8dd21d2&scoped=true"
import script from "./Lettering.vue?vue&type=script&setup=true&lang=js"
export * from "./Lettering.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Lettering.vue?vue&type=style&index=0&id=c8dd21d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dd21d2",
  null
  
)

export default component.exports